import React, {useEffect, useRef, memo} from "react";
import PropTypes from "prop-types";
import {NavItem, NavLink} from "reactstrap";
import {RiSpaceShipLine} from "react-icons/ri";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useLocation} from "react-router-dom";
import {
  requestSites,
  saveSelectedSite,
  updateSelectedLocation,
} from "../../redux/Actions/sites.actions";
import {
  getSiteList,
  getCurrentSite,
  getSitesNextUrl,
} from "../../redux/Selectors/sites.selectors";
import {getCurrentCustomer} from "../../redux/Selectors/customers.selectors";
import "./siteList.scss";

/** This Component will list sites in sidebar */

const SitesList = (props) => {
  const {closeCollapse = () => {}} = props;
  const navigate = useNavigate();
  const location = useLocation();
  const url = location.pathname;
  const params = url.split("/");
  const dispatch = useDispatch();
  const sites = useSelector(getSiteList);
  const sitesNext = useSelector(getSitesNextUrl);
  const currentCustomer = useSelector(getCurrentCustomer);
  const currentSite = useSelector(getCurrentSite);
  const loadMoreRef = useRef(null);
  const isFetchingRef = useRef(false);

  useEffect(() => {
    dispatch(requestSites());
  }, [currentCustomer, dispatch]);

  useEffect(() => {
    isFetchingRef.current = false;
  }, [sitesNext]);

  useEffect(() => {
    if (!sitesNext || !loadMoreRef.current) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !isFetchingRef.current) {
          isFetchingRef.current = true;
          dispatch(requestSites({}, sitesNext));
        }
      },
      {threshold: 0}
    );

    observer.observe(loadMoreRef.current);
    return () => observer.disconnect();
  }, [sitesNext, dispatch]);

  const handleSiteClick = (site) => {
    dispatch(saveSelectedSite(site));
    dispatch(updateSelectedLocation({}));
    navigate(`/app/sites/${site.id}`);
    closeCollapse();
  };

  return (
    <ul className="nav nav-sm flex-column">
      {sites && sites.length > 0 ? (
        <>
          {sites.map((site = {}) => (
            <NavItem
              key={site.id}
              data-cy="edit"
              onClickCapture={() => handleSiteClick(site)}
              style={{cursor: "pointer"}}
              className={`sidebar-site-option roboto-normal ${
                currentSite &&
                currentSite.id === site.id &&
                (params[2] === "sites" || params[2] === "appliance")
                  ? "active-sidebar-site"
                  : ""
              }`}
            >
              <NavLink className="d-flex align-items-center">
                <span className="sidebar-icon-container">
                  <RiSpaceShipLine className={"sidebar-icon"} fontSize={20} />
                </span>
                <span>{site.name}</span>
              </NavLink>
            </NavItem>
          ))}
          {sitesNext && <li ref={loadMoreRef} style={{height: "10px"}} />}
        </>
      ) : (
        <div
          style={{
            fontSize: "13px",
            padding: "15px",
          }}
          className="d-flex justify-content-center roboto-normal"
        >
          No sites available
        </div>
      )}
    </ul>
  );
};

SitesList.propTypes = {
  closeCollapse: PropTypes.func.isRequired,
};

export default memo(SitesList);
